import { Component, effect, OnInit, OnDestroy } from '@angular/core';
import { CdkDragDrop, moveItemInArray, CdkDropList, CdkDrag, CdkDragHandle } from '@angular/cdk/drag-drop';
import { ConversationService } from 'src/app/shared/services/conversation/conversation.service';
import { ltmsConversationDefaultProps } from '../../constants/default';
import { DomSanitizer } from '@angular/platform-browser';
import * as _ from 'lodash';
import { RichTextService } from 'src/app/shared/services/rich-text/rich-text.service';
import { EncoderService } from 'src/app/shared/services/encoder/encoder.service';
import { FormsModule } from '@angular/forms';
import { NgIf, NgFor, NgClass } from '@angular/common';
import { QuillEditorComponent } from 'ngx-quill';

interface Translation {
  key: string;
  value: string;
}

interface Language {
  id: string;
  name: string;
  native_name: string;
  is_default?: boolean;
  translations?: Translation[];
}

@Component({
  selector: 'app-litmus-intraction-languages',
  templateUrl: './litmus-intraction-languages.component.html',
  styleUrls: ['./litmus-intraction-languages.component.scss'],
  imports: [FormsModule, NgIf, NgFor, NgClass, CdkDropList, CdkDrag, CdkDragHandle, QuillEditorComponent]
})
export class LitmusIntractionLanguagesComponent implements OnInit, OnDestroy {
  // Data properties
  loading = true;
  searchText = '';
  configuration: any = {};
  // Language management
  availableLanguages: any = [];
  selectedLanguage: any | null = null;
  languages: any[] = [];
  defaultLanguage: string = 'english';
  languageLabels: any = {}

  labelsForEditing: any = {}
  // Modal properties
  editingLanguage: any = {
    id: '',
    name: '',
    native_name: '',
    translations: []
  };
  activeTab: 'basic' | 'advanced' = 'basic';
  showEditModal = false;
  selectedId: string = ''
  // UI states
  lan: any = null
  showAddLanguageModal = false;
  laguage_label_conditions: any = {}

  // Custom dropdown state
  dropdownOpen = false;

  isLanguageOrderDirty: boolean = false;

  dropdownSearchText: string = '';

  isUserHasWriteAccess: boolean = false;
  constructor(private _conversation: ConversationService,
    private _encoder: EncoderService,
    private _richTextService: RichTextService,
    private sanitizer: DomSanitizer) {
    effect(() => {
      const conversationObject = this._conversation.conversationObject();
      this.isUserHasWriteAccess = this._conversation.isUserHasWriteAccess('MANAGE_CONVERSATION');
      if (this._conversation.configuration && !_.isEmpty(this._conversation.configuration)) {
        this.configuration = Helpers.deepClone(this._conversation.configuration);
        this.languageLabels = Helpers.deepClone(this.configuration.languages)
        this.languages = []
        _.each(this.configuration.languages_order, (key: any) => {
          if (_.has(this.configuration, 'languages.' + key)) {
            const language: any = Helpers.deepClone(this.configuration.languages[key]);
            language.key = key
            this.languages.push(language)
          }
        });
        this.defaultLanguage = this._conversation.default_language;
      }
    });
  }

  ngOnInit(): void {
    this.loading = false;
    this.availableLanguages = ltmsConversationDefaultProps.languages;
    // console.log("this.availableLanguages",this.availableLanguages)
    this.defaultLanguage = this._conversation.default_language;
    document.addEventListener('click', this.handleOutsideClick);
  }

  ngOnDestroy(): void {
    document.removeEventListener('click', this.handleOutsideClick);
  }

  handleOutsideClick = (event: any) => {
    if (this.dropdownOpen) {
      const dropdown = document.querySelector('.custom-dropdown');
      if (dropdown && !dropdown.contains(event.target)) {
        this.closeDropdown();
      }
    }
  };

  toggleDropdown(): void {
    this.dropdownOpen = !this.dropdownOpen;
  }

  openDropdown(): void {
    this.dropdownOpen = true;
  }

  closeDropdown(): void {
    this.dropdownOpen = false;
  }

  selectDropdownLanguage(lang: any): void {
    this.selectedLanguage = lang;
    this.dropdownOpen = false;
    this.onLanguageSelectionChange();
  }

  // Modal methods
  showLabelFields: boolean = false
  editLanguage(language: any): void {
    this.showLabelFields = false;
    this.editingLanguage = _.cloneDeep(language);
    this.selectedId = language.key
    if (this.selectedId) {
      this.lan = _.find(this.availableLanguages, { 'key': this.selectedId });
      this.labelsForEditing = this.languageLabels[this.selectedId]['labels'] || {};
      this.laguage_label_conditions = this.languageLabels[this.selectedId]['dynamic_labels'] || {};
    } else {
      this.lan = null
    }
    if (!_.isEmpty(this.labelsForEditing)) {
      this.showLabelFields = true;
    }
    this.editingLanguage.translations = this.editingLanguage.translations || [];
    this.activeTab = 'basic';
    this.showEditModal = true;

  }

  closeEditModal(): void {
    this.showEditModal = false;
    this.editingLanguage = {
      id: '',
      name: '',
      native_name: '',
      translations: []
    };
  }

  setActiveTab(tab: 'basic' | 'advanced'): void {
    if (this.activeTab != tab) {
      this.activeTab = tab;
      if (tab == 'advanced') {
        //binding the dynamic condition data
        this.laguage_label_conditions = this.languageLabels[this.selectedId]['dynamic_labels'] || {};
        this.extractTags();
        this.createUniqueDynamicLabels();
      }
    }

  }



  addLanguage() {
    if (!this.isUserHasWriteAccess) {
      Helpers.smallAlertBox('Access Denied', 'You do not have write permission to add a new language. Only read access is available.', 'warning', 4000);
      return;
    }
    let lan: any = _.find(this.availableLanguages, { key: this.selectedId });
    // language object sample : 'english':{'display_name':'English', labels':{'labelId1':'How was experience?'}};
    if (this.selectedId) {
      // prepare and validate the data before save
      this.validateDataBeforeSave();
      // languages.lan = null;
      this.languageLabels[this.selectedId]['dynamic_labels'] = this.laguage_label_conditions || {};
    } else {
      lan = Helpers.deepClone(this.selectedLanguage)
      var languageKey = Helpers.removeSpecialCharacters(this.selectedLanguage.name, '_', false);
      if (!this.languageLabels[languageKey.toString()]) {
        this.languageLabels[languageKey.toString()] = {
          "display_name": lan["native_name"],
          "language": lan["name"],
          "time": (new Date()).getTime(),
          "labels": {},
          "dynamic_labels": {}
        }
        var labels = _.clone(this.languageLabels[this._conversation.default_language]['labels']);
        this.languageLabels[languageKey.toString()]['labels'] = labels;
        // $timeout(function() { $("#LanguagesList").val($("#LanguagesList").val()).trigger("change") })
        // languages.lan = null;
        this.selectedLanguage = null;
      }
    }

    if (lan && lan.key) {
      Object.keys(this.languageLabels[lan.key].labels).forEach((key) => {
        if (this.endsWith(key, '_rich')) {
          this.languageLabels[lan.key].labels[key] = this._richTextService.getHtml(this.languageLabels[lan.key].labels[key]);
        }
      });
    }

    this._conversation.configuration.languages = this.languageLabels;
    this._conversation.saveConversation(false, (this.selectedId) ? "Language Updated" : "Language Saved").then((response) => {
      this.showEditModal = false;
    })
    // this.showEditModal = false;
  }

  /**
   * Added by - Bhunesh on 22th Feb 2017
   * [setDefaultLanguage function to set default language]
   * @param {string} language - language which needs to be set as default
   */
  setDefaultLanguage(language) {
    Helpers.showConfirmationBox("Set default language", "Are you sure, you want to set this language as default?", (answer) => {
      if (answer) {
        var tmpConfiguration = Helpers.deepClone(this.configuration);
        try {
          var result = this._encoder.replaceKeys(this.configuration, this.configuration.default_language, language, ["languages"]);
          this.configuration = result;
        } catch (e: any) {
          this.configuration = tmpConfiguration;
          Helpers.smallAlertBox("Error", "Something went wrong", 1500);
          console.warn("Error:setDefaultLanguage()", e.toString());
        }
        setTimeout(() => {
          this._conversation.configuration = this.configuration
          this._conversation.default_language = language;
          this._conversation.language = this._conversation.default_language;
          this._conversation.configuration.default_language = language;
          var langIndex = this._conversation.configuration.languages_order.indexOf(language)
          this._conversation.configuration.languages_order.splice(0, 0, this._conversation.configuration.languages_order.splice(langIndex, 1)[0])
          this._conversation.saveConversation(false, "Default language has been to set").then((response) => {
            // this.showEditModal = false;
          })
        })
      }
    });
  }

  // prepare and validate data before save
  validateDataBeforeSave() {
    for (var key in this.laguage_label_conditions) {
      if (this.laguage_label_conditions.hasOwnProperty(key)) {
        var element = this.laguage_label_conditions[key];
        for (var key1 in element) {
          if (element.hasOwnProperty(key1)) {
            var element1 = element[key1];
            if (!element1.condition || !element1.label) {
              this.laguage_label_conditions[key].splice(key1, 1);
              continue;
            }
            if ('isNew' in element1) {
              delete this.laguage_label_conditions[key][key1].isNew;
            }
            if ('isOpen' in element1) {
              delete this.laguage_label_conditions[key][key1].isOpen;
            }
          }
        }
      }
    }
  }

  // Modal methods for adding new language
  openAddLanguageModal(): void {
    if (!this.isUserHasWriteAccess) {
      Helpers.smallAlertBox('Access Denied', 'You do not have write permission to add a new language. Only read access is available.', 'warning', 4000);
      return;
    }
    this.showAddLanguageModal = true;
    this.selectedLanguage = null;
    this.dropdownSearchText = '';
    this.closeDropdown();
  }

  closeAddLanguageModal(): void {
    this.showAddLanguageModal = false;
    this.selectedLanguage = null;
    this.dropdownSearchText = '';
    this.closeDropdown();
  }

  onLanguageSelectionChange(): void {
    // This method can be used for any additional logic when language selection changes
    // Currently it's just a placeholder for future enhancements
  }

  addNewLanguage(res: any): any {
    if (res && res.name) {
      var languageLabels = Helpers.deepClone(this.configuration.languages);
      var languageKey = res.key;
      if (!languageLabels[languageKey.toString()]) {
        var labels = _.clone(languageLabels[this._conversation.default_language]['labels']);
        // Insert the newly added language at the beginning of the list
        this.configuration.languages_order.unshift(languageKey.toString());
        languageLabels[languageKey.toString()] = {
          "display_name": res["native_name"],
          "language": res["name"],
          "time": (new Date()).getTime(),
          "labels": labels
        }
        
      } else {
        Helpers.smallAlertBox("Error", "Language already exists.", "error", 3000);
        this.closeAddLanguageModal();
        return true;
      }
      this.configuration.languages = languageLabels;
      this._conversation.configuration = Helpers.deepClone(this.configuration)
      this._conversation.saveConversation(false, (this.selectedId) ? "Language Updated" : "Language Saved").then((response) => {
        // this.showEditModal = false;
        this.closeAddLanguageModal();
      })
      
    } else {
      Helpers.smallAlertBox("Error", "Please select a language from list.", "error", 5500);
    }
    this.selectedLanguage = null;
  }

  // remove language method
  removeLanguage(languageKey) {
    if (this._conversation.default_language !== languageKey) {
      if (this.configuration.languages && this.configuration.languages[languageKey]) {
        Helpers.showConfirmationBox("Delete Language", "Are you sure, you want delete this language?", (answer) => {
          if (answer) {
            delete this._conversation.configuration.languages[languageKey.toString()];
            var langIndex = this._conversation.configuration.languages_order.indexOf(languageKey);
            this._conversation.configuration.languages_order.splice(langIndex, 1);
            this._conversation.saveConversation(false, "Language Removed").then((response) => {
              // this.showEditModal = false;
            })

          }
        });
      }
    } else {
      Helpers.smallAlertBox("Error", "Default language can not be deleted", "error", 1500);
    }

  };

  onDrop(event: CdkDragDrop<any[]>): void {
    if (event.previousIndex !== event.currentIndex) {
      moveItemInArray(this.languages, event.previousIndex, event.currentIndex);
      this._conversation.configuration.languages_order = this.languages.map(lang => lang.key);
      this.isLanguageOrderDirty = true;
    }
  }

  get filteredLanguages(): any {
    if (!this.searchText || this.searchText.trim() === '') {
      return this.languages;
    }
    const searchTerm = this.searchText.toLowerCase().trim();
    return this.languages.filter(lang => {
      const name = lang?.name || lang?.key || lang?.language
      return name.toLowerCase().includes(searchTerm)
    }
    );
  }

  get languagesForSelection(): any {
    return this.availableLanguages.filter(lang =>
      !this.languages.some(added => added.id === lang.id)
    );
  }

  trustHTML(string) {
    return this.sanitizer.bypassSecurityTrustHtml(string);
  }

  getLabelById(language, labelId) {
    if (labelId && language) {
      var label;
      try {
        label = this.configuration.languages[language.toString()]['labels'][labelId.toString()];
      } catch (e) {

      }
      return label ? label : "";
    }
    return;
  }


  isLabelRich(labelKey) {
    return this.endsWith(labelKey, '_rich');
  }

  endsWith(str, suffix) {
    return str.slice(-suffix.length) === suffix;
  }

  getLabels(key: any) {
    return (!_.isEmpty(this.labelsForEditing)) ? Object.keys(this.labelsForEditing) : [];
  }

  label_text_tags: any = {}
  totalTaggedLabels: number = 0
  uniqueDynamicLabels: any = {}
  displayConditionMap: any = {}
  isTagValuesAvailables: boolean = false;
  // extracting the tag variables from the interaction text
  extractTags() {
    this.isTagValuesAvailables = false;
    this.label_text_tags[this.selectedId] = {
      tag_vlues: []
    };
    this.totalTaggedLabels = 0;
    var languageLabels = this.languageLabels[this.selectedId].labels;
    var regExp = /[^{\}]+(?=})/g;
    _.each(languageLabels, (labelText: string, key: any) => {
      if (labelText) {
        var dynamicTags = labelText.match(regExp);
        if (dynamicTags != null) {
          for (var i = 0; i < dynamicTags.length; i++) {
            var tagKeyword = dynamicTags[i].trim();
            if (this.label_text_tags[this.selectedId].tag_vlues.indexOf(tagKeyword) < 0) {
              this.totalTaggedLabels++;
              this.label_text_tags[this.selectedId].tag_vlues.push(tagKeyword);
              this.uniqueDynamicLabels[tagKeyword] = {};
              this.displayConditionMap[tagKeyword] = {
                isDisplayCondtionActive: false
              };
            }
          }
          // console.log(" this.label_text_tags[this.selectedId]", this.label_text_tags)
        }
      }
    });
    if (!_.isEmpty(this.label_text_tags[this.selectedId].tag_vlues)) {
      this.isTagValuesAvailables = true
    }

  }

  createUniqueDynamicLabels() {
    _.each(this.laguage_label_conditions, (dynamic_labels, key) => {
      for (var index = 0, len = dynamic_labels.length; index < len; index++) {
        var label = dynamic_labels[index];
        if (label) {
          this.uniqueDynamicLabels[key][label.label] = (index + 1).toString();
        }
      }
    });
  }

  getTagValues(key: any) {
    return (_.has(this.label_text_tags, key + ".tag_vlues") && !_.isEmpty(this.label_text_tags[key].tag_vlues)) ? this.label_text_tags[key].tag_vlues : [];
  }

  // add a new condition
  addCondition(tag, index) {
    if (!this.isUserHasWriteAccess) {
      Helpers.smallAlertBox('Access Denied', 'You do not have write permission to add a new condition. Only read access is available.', 'warning', 4000);
      return;
    }
    var logic = this.laguage_label_conditions[tag][index]
    var validObj = this.formValidity(tag, logic);
    if (validObj.status) {
      this.laguage_label_conditions[tag][index] = {
        label: logic.label,
        condition: logic.condition
      }
      this.uniqueDynamicLabels[tag][logic.label] = parseInt(index + 1);
      this.displayConditionMap[tag].isDisplayCondtionActive = false;
    } else {
      Helpers.smallAlertBox("Error", validObj.message, "error", 5000);
    }
  }

  oldCondition: string = '';
  oldLabel: string = '';
  // close the condition editor
  closeCondition(tag, index) {
    // if add new condition and closing the condition box
    if (this.laguage_label_conditions[tag][index].condition && this.laguage_label_conditions[tag][index].label && this.laguage_label_conditions[tag][index].isNew) {
      this.laguage_label_conditions[tag].splice(index, 1);
    }
    // if adding new condition and both condition and labe is not there 
    else if (!this.laguage_label_conditions[tag][index].condition && !this.laguage_label_conditions[tag][index].label && this.laguage_label_conditions[tag][index].isNew) {
      this.laguage_label_conditions[tag].splice(index, 1);
    }
    // in edit mode
    else {
      if (this.oldCondition !== this.laguage_label_conditions[tag][index].condition) {
        this.laguage_label_conditions[tag][index].condition = this.oldCondition;
      }
      this.laguage_label_conditions[tag][index].isOpen = false;
    }
    this.displayConditionMap[tag].isDisplayCondtionActive = false;
  }
  // validate the logic
  formValidity(tag, logic) {
    // this will check the logic is valid or not
    if (!logic.label || !logic.condition) {
      return { status: false, message: logic.label ? 'Please provide translation text!' : 'Please provide translation condition!' }
    }
    // it will check for the current value while edit
    if (this.oldLabel === logic.label && !logic.isNew) {
      return { status: true, message: '' };
    }
    // this will check for unique validation
    if (this.uniqueDynamicLabels[tag][logic.label]) {
      return { status: false, message: 'You have already entered this same translation text!' };
    }
    return { status: true, message: '' };
  }

  // edit te dynamic label
  editDynamicLabelCondition(logicObj: any, tag: any) {
    this.displayConditionMap[tag].isDisplayCondtionActive = true;
    this.oldCondition = logicObj.condition;
    this.oldLabel = logicObj.label;
    if (logicObj && !logicObj.isOpen) {
      logicObj.isOpen = true;
      logicObj.isNew = false;
    }
  }

  // remove the dynamic label
  removeDynamicLabelCondition(tag, logic, index) {
    this.laguage_label_conditions[tag].splice(index, 1);
    delete this.uniqueDynamicLabels[tag][logic.label];
    if (!this.laguage_label_conditions[tag].length) {
      this.displayConditionMap[tag].isDisplayCondtionActive = false;
    }
  }
  // adding dynamic label
  toggleDynamicLabelCondition(tag) {
    if (this.laguage_label_conditions[tag]) {
      this.laguage_label_conditions[tag].push({
        label: '',
        condition: '',
        isOpen: true,
        isNew: true
      });
    } else {
      this.laguage_label_conditions[tag] = [{
        label: '',
        condition: '',
        isOpen: true,
        isNew: true
      }];
    }
    this.displayConditionMap[tag].isDisplayCondtionActive = true;
  }

  // checking for valid condition and label
  isValid(obj) {
    // this condition is for checking the key is available or not in the object or the condition is in edit mode
    if ((!('isNew' in obj) && !('isOpen' in obj)) || !obj.isNew) {
      return true;
    }
    // this condition is for creating new object that time it shouldn't render
    else if (obj.isNew) {
      return false;
    }
    // if both condition and label is there then only render the object
    else if (obj.label && obj.condition) {
      return true;
    }
    return false;
  }

  saveLanguageOrder(): void {
    // Implement your save logic here, e.g., call an API or update the backend
    // For now, just reset the dirty flag and show a message
    this._conversation.saveConversation(false, 'Language order updated').then(() => {
      this.isLanguageOrderDirty = false;
    });
  }

  filteredAvailableLanguages(): any[] {
    // First, filter out languages that are already added to the language list
    const addedLanguageKeys = this.languages.map(lang => lang.key);
    const availableLanguages = this.availableLanguages.filter(lang =>
      !addedLanguageKeys.includes(lang.key)
    );

    // Then apply search filter if search text exists
    if (!this.dropdownSearchText || this.dropdownSearchText.trim() === '') {
      return availableLanguages;
    }

    const searchTerm = this.dropdownSearchText.toLowerCase().trim();
    return availableLanguages.filter(lang => {
      const name = lang?.name || '';
      const key = lang?.key || '';
      const nativeName = lang?.native_name || '';
      return name.toLowerCase().includes(searchTerm) ||
        key.toLowerCase().includes(searchTerm) ||
        nativeName.toLowerCase().includes(searchTerm);
    });
  }

  get hasAvailableLanguages(): boolean {
    const addedLanguageKeys = this.languages.map(lang => lang.key);
    return this.availableLanguages.some(lang => !addedLanguageKeys.includes(lang.key));
  }
}


